/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import ChartConst from '../../../constants/chart.constant';
import d3 from '../../../globalexports/d3.export';

function windStripService() {
  const content = {};
  content.drawWindStrip = (
    sourceData,
    chartData,
    chartObj,
    x,
    xKey,
  ) => {
    if (!sourceData) {
      return;
    }

    // Setting Domain for X-axis
    x.domain(d3.extent(sourceData, (d) => d[xKey]));

    // Filter out wgs (wind gust) series. Dont want to draw connecting
    //  line on windgust scattered plot
    chartObj.selectAll('.series')
      .data(() => chartData.filter((d) => (d.key !== ChartConst.ChartLabelSpecs.wgs.key)))
      .enter().append('g')
      .attr('class', (d) => `series-${d.sequence}`);
  };
  return content;
}
export default windStripService();
